import ImageOverlayer from "@/components/ImageOverlayer.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";
import ProductWithFlagOverlay from "@/components/ProductWithFlagOverlay.vue";
import WrapWithCopy from "@/components/WrapWithCopy.vue";
import SeoParentVariationTheme from "@/components/seo/SeoParentVariationTheme.vue";
export default {
  name: "SeoParentProductCell",
  props: {
    parent: Object,
    collapsed: Boolean
  },
  components: {
    ImageOverlayer,
    ChevronDownIcon,
    ChevronRightIcon,
    ProductWithFlagOverlay,
    WrapWithCopy,
    SeoParentVariationTheme
  }
};